import { SITE_URL, SITE_NAME } from './seoConfig';
import { AI_BRAND, AI_CITATION } from './aiKnowledge';

export const AI_META_TAGS = [
  { name: 'author', content: SITE_NAME },
  { name: 'application-name', content: SITE_NAME },
  { name: 'generator', content: `${SITE_NAME} — Thai lottery dream interpretation` },
  {
    name: 'abstract',
    content: AI_CITATION.short,
  },
  {
    name: 'ai-content-declaration',
    content: 'human-authored-reference-data',
  },
  {
    name: 'referrer',
    content: 'origin-when-cross-origin',
  },
];

export const AI_LINK_TAGS = [
  { rel: 'llms', href: `${SITE_URL}/llms.txt` },
  { rel: 'alternate', type: 'text/plain', href: `${SITE_URL}/llms.txt`, title: 'LLM site map (llms.txt)' },
  { rel: 'alternate', type: 'text/plain', href: `${SITE_URL}/llms-full.txt`, title: 'LLM full reference (llms-full.txt)' },
  { rel: 'describedby', href: `${SITE_URL}/llms.txt` },
];

export function buildAiCitationMeta(canonicalUrl) {
  return [
    { name: 'citation_public_url', content: canonicalUrl },
    { name: 'citation_publisher', content: AI_BRAND.name },
    { property: 'article:publisher', content: SITE_URL },
  ];
}
